import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "no-affiliation",
  "use": "no-affiliation-usage",
  "viewBox": "0 0 640 640",
  "content": "<symbol viewBox=\"0 0 640 640\" id=\"no-affiliation\"><path d=\"M450.88 71.456C414.4 45.152 368.576 32 313.408 32c-41.952 0-77.376 9.248-106.144 27.776-45.664 28.992-69.92 78.24-72.864 147.68h105.824c0-20.256 5.92-39.68 17.696-58.496 11.808-18.752 31.84-28.128 60.096-28.128 28.736 0 48.544 7.616 59.328 22.816 10.848 15.264 16.256 32.128 16.256 50.624 0 16.128-8.064 30.88-17.824 44.256-5.344 7.808-12.384 15.008-21.152 21.568 0 0-57.376 36.8-82.56 66.368-14.592 17.12-15.904 42.816-17.216 79.616-.064 2.624.928 8.064 10.08 8.064H347.2c8.192 0 9.888-6.048 9.984-8.768.576-13.376 2.048-20.256 4.512-28 4.608-14.624 17.216-27.36 31.328-38.368l29.12-20.064c26.304-20.512 47.264-37.312 56.544-50.496 15.808-21.632 26.944-48.32 26.944-80-.032-51.68-18.272-90.624-54.752-116.992zM311.712 477.568c-36.448-1.12-66.528 24.128-67.68 63.68-1.12 39.488 27.456 65.632 63.936 66.688 38.048 1.12 67.328-23.264 68.512-62.816 1.088-39.552-26.688-66.432-64.768-67.552z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/no-affiliation.svg
// module id = DoYb
// module chunks = 1